<template>
  <div>

    <!-- === Data table === -->
      <v-card>
        <v-card-title>
          <v-btn rounded class="mr-5" depressed color="primary" @click="handleAdd()">
            <v-icon class="mr-1" dark> mdi-plus-circle</v-icon>
            {{ $t("addNew") }}
          </v-btn>

          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="listCategories"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
        >
          <!-- Progressive -->
          <template v-slot:progress><v-progress-circular indeterminate color="green" :value="50"></v-progress-circular></template>

          <!-- Header -->
          <template v-slot:header.short_code="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.name="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.product_type="{ header }">{{ $t(header.text) }}</template>
          <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

          <!-- Body -->
          <template v-slot:item.action="{ item }">
            <v-btn color="primary" outlined class="table-action-button mr-2" text icon @click="handleEdit(item, $event)">
              <font-awesome-icon icon="edit"/>
            </v-btn>
            <v-btn color="error" outlined class="table-action-button" text icon
                  @click.native="handleRemove(item)">
              <font-awesome-icon icon="trash"/>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Pagination -->
        <div class="text-center pt-2">
          <v-card-actions>
            <v-col v-if="!$vuetify.breakpoint.xsOnly" class="d-flex" cols="12" sm="1">{{ $t("total") }} : {{ totalPage }}</v-col>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly"><v-select :label="$t('perPage')" v-model="itemsPerPage" :items="pageList"></v-select></v-col>
            <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
            ></v-pagination>
            <v-col class="d-flex" cols="12" sm="1" v-if="!$vuetify.breakpoint.xsOnly">
              <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
              ></v-text-field>
            </v-col>
          </v-card-actions>
        </div>
      </v-card>
    <!-- === End Data table === -->

    <!--=== Form add dialog section ==== -->
      <v-dialog v-model="dialog" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.mobile">
        <v-card>
          <v-card-title class="dialog-header">
            <span class="headline" v-if="toggleAdd">{{ $t("addCategory") }}</span>
            <span class="headline" v-if="!toggleAdd">{{ $t("editCategory") }}</span>
            <v-spacer></v-spacer>
            <v-btn
              fab
              text
              icon
              @click="dialog = false"
              valid="false"
              v-shortkey="['esc']"
              @shortkey.native="dialog = false"
            >
            <span class="white--text">
              <v-icon dark>
                mdi-close
              </v-icon>
            </span>
            </v-btn>
          
            </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="formData">
                  <v-container>
                    <v-row :no-gutters="$vuetify.breakpoint.mobile">

                         <v-col cols="12">
                          <v-text-field
                            v-model="formDoc.name"
                            :label="$t('categoryName') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>

                         <v-col cols="12">
                          <v-text-field
                            v-model="formDoc.shortCode"
                            :label="$t('code') + '*'"
                            :rules="valueRules"
                            required
                            outlined
                            
                            dense
                          ></v-text-field>
                        </v-col>

                         <v-col cols="12">
                            <v-autocomplete
                              v-model="formDoc.productType"
                              :items="parentCategories"
                              item-name="product_type"
                              item-value="product_type"
                              outlined
                              :dense="dense"
                              :label="$t('productType')"
                              clearable
                              :rules="valueRules"
                              required
                            >
                              <template v-slot:item="{item}">{{$t(item.product_type)}}</template>
                              <template v-slot:selection="{item}">{{$t(item.product_type)}}</template>
                            </v-autocomplete>
                        </v-col>

                         <v-col cols="12">
                            <v-checkbox
                              v-model="formDoc.addAsSubCategory"
                              :label="$t('addAsSubCategory')"
                              style="margin-top: -10px !important"
                            ></v-checkbox>
                        </v-col>

                         <v-col cols="12" v-if="formDoc.addAsSubCategory">
                            <v-autocomplete
                              v-model="formDoc.parentCategory"
                              :items="childCategories"
                              item-text="name"
                              item-value="id"
                              outlined
                              :dense="dense"
                              auto-select-first
                              :label="$t('parentCategory')"
                              clearable
                            >
                            </v-autocomplete>
                        </v-col>

                    </v-row>

                  </v-container>
                </v-form>
              </v-card-text>
            <v-card-actions>

            <v-spacer></v-spacer>
            <v-btn color="default" outlined text @click="dialog = false">
              {{ $t('close') }}
            </v-btn>
            <v-btn class="ma-2 v-btn v-btn--contained theme--light v-size--default success white--text" text @click="submit($event)">
              <font-awesome-icon icon="check-circle" class="mr-1"/>
              {{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    <!--=== End Form add dialog section ==== -->

  </div>
</template>

<script>
import validatorMixin from "@/mixins/validatorMixin";
import mainMixin from "@/mixins/mainMixin";
import optionDataMixin from "@/mixins/optionDataMixin";
import axios from "axios";
import { provider } from "../../../service/provider";
import _ from "lodash";

export default {
  name: "Category",
  mixins: [validatorMixin, mainMixin, optionDataMixin],
  data() {
    return {
      headers: [
        {
          text: "code",
          value: "short_code",
          sortable: true,
        },
        { 
          text: "categoryName", 
          value: "name",
          sortable: true,
        },
        { 
          text: "productType", 
          value: "product_type",
          sortable: true,
        },
        { text: "action", value: "action", sortable: false, width: 115 }
      ],
      formDoc: {
        id: "",
        shortCode: "",
        name: "",
        productType: "",
        addAsSubCategory: false,
        parentCategory: "",
      },
    };
  },
  mounted() {},
  methods: {
    reset() {
      let vm = this;
      if (vm.$refs.formData) {
          vm.$refs.formData.resetValidation();
          vm.formDoc.id           = "";
          vm.formDoc.shortCode   = "";
          vm.formDoc.name         = "";
          vm.formDoc.productType  = "";
          vm.formDoc.addAsSubCategory = false;
          vm.formDoc.parentCategory= "";
      }
    },

    handleAdd() {
      let vm = this;
      vm.reset();
      vm.dialog = true;
      vm.toggleAdd = true;
    },

    handleClose() {
        this.dialog = false;
        this.reset();
    },

    handleRemove(item) {
      let vm = this;
      vm.$confirm(vm.$t("thisWillDelete") + item.id + ' . ' + vm.$t('continue') + '?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        vm.removeTransaction(item.id);
      }).catch(() => {
        vm.$message({
          type: 'info',
          message: vm.$t('deleteCancel')
        });
      });
    },

    removeTransaction(id) {
      let vm = this;
      let url = provider.baseURL + provider.destroyCategory;
      return new Promise((resolve, reject) => {
        axios.post(url, {id: id}, {headers: {Authorization: localStorage.token}}).then(
            res => {
              if (res.data.response && res.data.response.code === 200) {
                resolve(res.data.data);
                vm.$message({
                  type: 'success',
                  message: vm.$t('deleteComplete')
                });
                vm.fetchDataTable();
              }
            },
            error => {
              reject(error);
            }
        );
      });
    },

    handleEdit(item, event) {
      event.preventDefault();
      let vm        = this;
      vm.overlay    = true;
      vm.dialog     = true;
      vm.toggleAdd  = false;
    

      if(Object.keys(item).length){
        vm.formDoc.id         = item.id; 
        vm.formDoc.shortCode  = item.short_code;
        vm.formDoc.name       = item.name;
        vm.formDoc.productType= item.product_type;

        if(parseInt(item.parent_id)) {
          vm.formDoc.addAsSubCategory = true;
          vm.formDoc.parentCategory = item.parent_id;
        }else{
          vm.formDoc.addAsSubCategory = false;
          vm.formDoc.parentCategory = "";
        }
      }
    },

    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.fetchTransactionCategory({
        search: vm.search,
        id: "",
        offset: vm.currentPage,
        limit: vm.itemsPerPage,
        sortBy: vm.options.sortBy[0] || "created_at",
        sortDesc: vm.options.sortDesc[0]===false ? 0 :1
      });
      
    }, 350),

    submit(e) {
      e.preventDefault();
      let vm = this;
      if (vm.$refs.formData.validate()) {
            vm.overlay = true;

          let url = provider.baseURL + provider.storeCategory;

          let params = {
            id: vm.formDoc.id,
            name: vm.formDoc.name,
            short_code: vm.formDoc.shortCode,
            parent_id: vm.formDoc.parentCategory,
            product_type: vm.formDoc.productType
          }

          return new Promise((resolve, reject) => {
              axios.post(url, params, {headers: {Authorization: localStorage.token}}).then(
                  res => {
                      if (res.data.response && res.data.response.code === 200) {
                          vm.$notify({
                              title: "Success",
                              message: vm.$t("success"),
                              type: "success",
                              duration: 700
                          });
                          vm.dialog = false;
                          vm.fetchDataTable();
                          vm.overlay=false;
                      }
                  },
                  error => {
                      reject(error);
                  }
              );
          });
      }
    }
  },
  created() {
    this.fetchDataTable();
  },
  computed:{},
  watch: {
    search() {
      this.fetchDataTable();
    },
    currentPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    itemsPerPage() {
      this.loading = true;
      this.fetchDataTable();
    },
    "formDoc.addAsSubCategory"(val){
      if(! val) { this.formDoc.parentCategory = ''; }
    },
    "formDoc.productType"(val){
      if(val){
        this.fetchChildCategory({productType: val})
      }
    },
    dialog(val){
      if(val){
        this.fetchParentCategory();
      }
    }
  }
  
};
</script>